import { createSlice } from "@reduxjs/toolkit"

const feedBacksSlice = createSlice({
  name: 'feedBacks',
  initialState: {
    feedBacks: null,
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateFeedBacks: (state, action) => {
      state.feedBacks = action.payload
    },
    addFeedBack: (state, action) => {
      const feedBack = action.payload
      state.feedBacks = { ...state.feedBacks, [feedBack.id]: feedBack }
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { addFeedBack, fullUpdate, updateFeedBacks, updateErrors } = feedBacksSlice.actions

export default feedBacksSlice.reducer